import { useUserData } from '../contexts/UserDataContext';

export function OrderHistoryTab() {
  const { orderHistory, isConnected, isInitialLoad } = useUserData();

  const showEmptyState = !isConnected || (isInitialLoad && orderHistory.length === 0) || orderHistory.length === 0;
  const emptyMessage = !isConnected
    ? 'Connect wallet to view order history'
    : isInitialLoad && orderHistory.length === 0
    ? 'Loading order history...'
    : 'No order history';

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'filled':
        return 'text-[#0ecb81]';
      case 'cancelled':
      case 'canceled':
        return 'text-[#f6465d]';
      case 'open':
      case 'resting':
        return 'text-[#2962ff]';
      default:
        return 'text-[#6c7884]';
    }
  };

  return (
    <div className="h-full bg-[#0e0f10]">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#1a1d20]">
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Time
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Market
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Type
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Side
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Size
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Price
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Filled
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {showEmptyState ? (
            <tr>
              <td colSpan={8} className="px-3 py-8 text-center text-[#6c7884] text-[13px]">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            orderHistory.map((entry, idx) => {
              const { order, status, statusTimestamp } = entry;
              const isBuy = order.side === 'B';
              const origSize = parseFloat(order.origSz);
              const remainingSize = parseFloat(order.sz);
              const filledSize = origSize - remainingSize;
              const filledPercent = origSize > 0 ? (filledSize / origSize) * 100 : 0;
              const date = new Date(statusTimestamp);

              return (
                <tr key={order.oid || idx} className="hover:bg-[#13141a] transition-colors">
                  <td className="px-3 py-3 text-[#6c7884] text-[12px]">
                    {date.toLocaleDateString()} {date.toLocaleTimeString()}
                  </td>
                  <td className="px-3 py-3 text-white font-medium text-[12px]">
                    {order.coin}
                  </td>
                  <td className="px-3 py-3 text-[#6c7884] text-[12px]">
                    Limit
                  </td>
                  <td className="px-3 py-3">
                    <span className={`text-[12px] font-medium ${
                      isBuy ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                    }`}>
                      {isBuy ? 'Buy' : 'Sell'}
                    </span>
                  </td>
                  <td className="px-3 py-3 text-right text-white text-[12px]">
                    {origSize.toFixed(4)}
                  </td>
                  <td className="px-3 py-3 text-right text-white text-[12px]">
                    ${parseFloat(order.limitPx).toFixed(2)}
                  </td>
                  <td className="px-3 py-3 text-right text-white text-[12px]">
                    {filledSize.toFixed(4)} ({filledPercent.toFixed(0)}%)
                  </td>
                  <td className={`px-3 py-3 text-[12px] font-medium ${getStatusColor(status)}`}>
                    {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
